import { render, staticRenderFns } from "./bin-movement.vue?vue&type=template&id=08cc2a96"
import script from "./bin-movement.vue?vue&type=script&lang=js"
export * from "./bin-movement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports